import {
  FETCH_QUESTION_LIST,
  ADD_QUESTION,
} from '../mutation-types'

const initialState = {
  questions: [],
}

const mutations = {
  [FETCH_QUESTION_LIST](state, questions) {
    state.questions = questions.questions
  },
  [ADD_QUESTION](state, data) {
    state.questions.unshift(data)
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/question.js